import { all, call, SagaReturnType, takeLatest } from "redux-saga/effects";

import { loadInfoScreen, updateInfoScreen } from 'api/infoScreens';
import { loadInfoScreenAction, updateInfoScreenAction } from './infoScreens.actions';

function* loadInfoScreenFlow(action: typeof loadInfoScreenAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof loadInfoScreen> = yield call(loadInfoScreen, action.payload);
    yield call(loadInfoScreenAction.sagas.resolve, action, data);
  } catch (e: any) {
    yield call(loadInfoScreenAction.sagas.reject, action, e?.message);
  }
}

function* updateInfoScreenFlow(action: typeof updateInfoScreenAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof updateInfoScreen> = yield call(updateInfoScreen, action.payload);
    yield call(updateInfoScreenAction.sagas.resolve, action, data);
  } catch (e: any) {
    yield call(updateInfoScreenAction.sagas.reject, action, e?.message);
  }
}

export default function* infoScreensSaga() {
  yield all([
    takeLatest(loadInfoScreenAction.trigger, loadInfoScreenFlow),
    takeLatest(updateInfoScreenAction.trigger, updateInfoScreenFlow),
  ]);
}